export default {
    confirmPassword: 'Confirm @.lower:password',
    consumer: 'Consumer | Consumers',
    dashboard: 'Dashboard | Dashboards',
    displayName: 'Display name | Display names',
    email: 'E-mail | E-mails',
    file: 'File | Files',
    login: 'Login',
    name: 'Name | Names',
    password: 'Password | Passwords',
    project: 'Project | Projects',
    register: 'Register',
    registered: 'Registered',
    resetPassword: 'Reset Password',
    service: 'Service | Services',
    setting: 'Setting | Settings',
    user: 'User | Users',
    worker: 'Worker | Workers',
    questions: {
        forgotPassword: 'Forgot @:password',
    },
}
